import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { AuthenticationService } from '../../services/authentication-service/authentication.service';
import { UtilService } from '../../services/util-service/util.service';
import { ErrorModalComponent } from '../../dialogs/error-modal';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  imports: [TranslateModule, RouterModule],
})
export class AuthenticateComponent implements OnInit {
  iframeSrc: SafeResourceUrl;
  rspAuthenticateTitle = 'Authenticate';

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly config: AppConfigService,
    private readonly translate: TranslateService,
    private readonly utils: UtilService,
    private readonly modalService: NgbModal,
    @Inject(DOCUMENT) private readonly document: Document,
    public sanitizer: DomSanitizer,
    public route: ActivatedRoute
  ) {
    this.iframeSrc = sanitizer.bypassSecurityTrustResourceUrl('');
  }

  ngOnInit(): void {
    this.authenticationService.getLoginPath(this.config.configurationId, this.translate.currentLang).subscribe(loginPath => {
      if (this.config.configData.externalAuth) {
        window.location.href = loginPath;
      } else {
        this.iframeSrc = this.utils.handleIFrameUrl(loginPath);
      }
    });
    this.route.queryParams.subscribe(p => {
      if (p?.error) {
        this.showErrorModal(p.error);
      }
    });
  }

  showErrorModal(modalBodyKey: string): NgbModalRef {
    let modal: NgbModalRef = this.modalService.open(ErrorModalComponent, {
      ariaLabelledBy: 'error-modal-title',
      ariaDescribedBy: 'error-modal-body',
    });
    modal.componentInstance.modalBodyKey = modalBodyKey;
    modal.componentInstance.modalTitleKey = 'rspModalGeneralHeading';
    modal.componentInstance.modalButtonCloseKey = 'rspModalButtonClose';
    return modal;
  }
}
